import { PlaycastMessage, PlaycastMessageStateReplication, PlaycastRemoteMessages, PlaycastStateMessages } from '@playcastdotio/Messaging';
import { SharedStateStores } from '../../stores';

export const handleIncomingRemoteMessage = (message: PlaycastMessage<PlaycastRemoteMessages>, store: SharedStateStores) => {
  const action = message.header.action;
  const isReply = message.header.isReply;
  console.log('[RC-Handler] Remote message:', action, isReply);
};

export const handleIncomingStateMessage = (message: PlaycastMessage<PlaycastStateMessages>, stores: SharedStateStores) => {
  const action = message.header.action;
  const isReply = message.header.isReply;
  switch (action) {
    case 'replication':
      if (!isReply) {
        const validatedMessage = message as PlaycastMessage<PlaycastMessageStateReplication<keyof SharedStateStores>>;
        const channel = validatedMessage.body.message.channel;
        if (stores[channel]) {
          stores[channel].updateState(validatedMessage.body.message.state as never);
        } else {
          console.error('[RC-Handler] Invalid channel:', channel);
        }
      }
      break;
  }
};
